<template>
  <div>
    <ModalConfirm
      id="evaluation-starter"
      status="star"
      title="Sebelum Melakukan Pembayaran"
      description="Kamu harus memberikan penilaian terhadap Performa Talent terlebih dahulu."
      cancel-label="Batal"
      confirm-label="Lanjutkan"
      :loading="loading"
      @onConfirm="handleOpenEvaluation"
    />
    <Modal
      id="evaluation"
      dialog-class="md:min-w-[700px] lg:min-w-[768px]"
    >
      <div class="sm:pl-[12px] sm:pr-[6px] py-[8px] sm:py-[20px]">
        <b class="font-semibold text-[20px] text-[#333333]">Evaluasi Talent</b>
        <div class="flex mt-[24px] gap-[24px] flex-wrap">
          <div class="grow basis-[280px] rounded-[8px] text-black bg-[#F4F4F4] px-[24px] py-[12px] flex flex-col gap-[8px] h-fit">
            <b class="text-[14px] font-medium">Cara memberi rating instan :</b>
            <p class="text-[12px] mb-[8px]">
              Tandai semua talent, kemudian pilih rate yang mau kamu berikan kepada talent
            </p>
            <span class="text-[12px] font-medium">Rating</span>
            <div class="flex gap-[8px]">
              <span
                v-for="i in 5"
                :key="i"
                class="rounded-[6px] bg-[#E2E2E2] h-[32px] grow grid place-items-center font-medium text-[14px]"
              >{{ i }}</span>
            </div>
            <div class="flex justify-between gap-[8px] text-[12px]">
              <span class="text-[#E31A1A]">Buruk</span>
              <span class="text-[#34A770]">Sangat Bagus</span>
            </div>
          </div>
          <div class="grow basis-[320px] overflow-hidden">
            <div class="flex items-center gap-[10px] rounded-[8px] bg-[#DFF3FF] py-[6px] px-[10px] text-[#0F679A] mb-[14px] sm:mr-[6px]">
              <i class="k-info-circle-1 text-[24px] font-medium" />
              <span class="text-[10px]">Dapatkan 500 poin KomPoint dengan mengisi evaluasi minimal 20 karakter!</span>
            </div>
            <div class="flex items-center gap-[16px] pb-[12px] border-b border-[#E2E2E2] sm:pr-[6px]">
              <label
                for="select-all"
                class="cursor-pointer m-0 w-[calc(100%-168px)] text-[14px] font-semibold flex gap-[8px] items-center"
              >
                <input
                  id="select-all"
                  type="checkbox"
                  name="select-all"
                  class="peer hidden"
                  @input="handleSelectAllInput"
                >
                <i class="k-Checklist text-[22px] w-[18px] h-[18px] border-[1.5px] border-[#E2E2E2] rounded-[3px] flex items-center justify-center text-white peer-checked:border-[#F95031] peer-checked:bg-[#F95031] peer-checked:shadow-[0_2px_4px_0] peer-checked:shadow-[#7367F0]/40 transition-colors duration-300" />
                Semua Talent
              </label>
              <div class="flex flex-row-reverse gap-[8px] w-[152px]">
                <label
                  v-for="i in 5"
                  :key="i"
                  :for="`rate-all-${i}`"
                  class="rate cursor-pointer  m-0 w-[24px] h-[24px] rounded-[6px] border-[1px] grid place-items-center font-semibold text-[14px] transition-colors duration-300"
                >
                  <input
                    :id="`rate-all-${i}`"
                    :value="5 - i + 1"
                    type="radio"
                    name="rate-all"
                    class="hidden"
                    @input="handleSelectRate"
                  >
                  {{ 5 - i + 1 }}
                </label>
              </div>
            </div>
            <form
              ref="evaluation"
              class="max-h-[300px] overflow-y-auto py-[4px] sm:pr-[6px]"
              @submit.prevent="$refs.submit.click()"
            >
              <div
                v-for="talent, idx in talents"
                :key="idx"
                class="py-[8px]"
              >
                <div class="flex items-center gap-[16px]">
                  <label
                    :for="`select-${idx}`"
                    class="cursor-pointer m-0 w-[calc(100%-168px)] text-[14px] flex gap-[8px] items-center"
                  >
                    <input
                      :id="`select-${idx}`"
                      type="checkbox"
                      name="select-talent"
                      class="peer hidden"
                      @input="handleSelectInput"
                    >
                    <i class="k-Checklist text-[22px] w-[18px] h-[18px] border-[1.5px] border-[#E2E2E2] rounded-[3px] flex items-center justify-center text-white peer-checked:border-[#F95031] peer-checked:bg-[#F95031] peer-checked:shadow-[0_2px_4px_0] peer-checked:shadow-[#7367F0]/40 transition-colors duration-300" />
                    <span class="truncate">{{ talent.talent_name || talent.staff_name }}</span>
                  </label>
                  <div
                    ref="rate"
                    class="flex flex-row-reverse gap-[8px] w-[152px]"
                  >
                    <label
                      v-for="i in 5"
                      :key="i"
                      :for="`rate-${idx}-${i}`"
                      class="cursor-pointer rate m-0 w-[24px] h-[24px] rounded-[6px] border-[1px] grid place-items-center text-[14px] transition-colors duration-300"
                    >
                      <input
                        :id="`rate-${idx}-${i}`"
                        :value="5 - i + 1"
                        type="radio"
                        :name="`rate-${idx}`"
                        class="hidden"
                        @input="rateAndDisable"
                      >
                      {{ 5 - i + 1 }}
                    </label>
                  </div>
                </div>
                <div class="mt-[4px] relative">
                  <textarea
                    :id="`eval-${idx}`"
                    :name="`eval-${idx}`"
                    rows="1"
                    placeholder="Beri Evaluasi Anda Pada Kinerja Talent"
                    class="placeholder-ellipsis w-full pl-[10px] pr-[30px] py-[8px] text-[12px] text-[#333333] outline-none border-[1px] border-[#CCCCCC] rounded-[8px] block"
                    @input="e => handleEvaluationInput(e, idx)"
                  />
                  <span
                    :id="`counter-${idx}`"
                    class="text-[10px] text-[#828282] block mt-[4px] text-right"
                  />                  <button
                    type="button"
                    aria-label="eval-toggle"
                    class="outline-none border-none w-[18px] h-[18px] flex items-center justify-center absolute top-[8px] right-[10px] rounded-[4px] hover:bg-[#F8F8F8] active:bg-[#F4F4F4] transition-colors duration-300"
                    @click="() => handleToggleEvaluation(idx)"
                  >
                    <i
                      :id="`arrow-${idx}`"
                      class="k-arrow-down-1 text-[16px] transition-transform duration-300"
                    />
                  </button>
                </div>
              </div>
            </form>
            <b-button
              ref="submit"
              variant="primary"
              class="grow whitespace-nowrap mt-[28px] w-full"
              disabled
              @click="handleSubmitEvaluation"
            >
              <b-spinner
                v-if="loading"
                class="mr-[6px]"
                small
              />
              Beri Penilaian
            </b-button>
          </div>
        </div>
      </div>
    </Modal>
    <ModalConfirm
      id="evaluation-success"
      title="Evaluasi Berhasil Disimpan"
      :description="!amount ? null : `Kamu mendapatkan ${amount} poin KomPoint!`"
      confirm-label="Bayar Invoice"
      @hidden="$emit('confirm')"
      @onConfirm="$bvModal.hide('evaluation-success')"
    />
  </div>
</template>

<script>
import { komtimAxiosIns } from '@/libs/axios'
import Modal from './Modal.vue'
import ModalConfirm from './ModalConfirm.vue'

export default {
  components: { ModalConfirm, Modal },
  props: {
    invoiceId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      talents: [],
      loading: false,
      amount: 0,
    }
  },
  methods: {
    async handleOpenEvaluation() {
      try {
        this.loading = true
        const { data: { data: { talents, talent_leader } } } = await komtimAxiosIns.get('/v1/talents/assigned', { params: { invoice_id: this.invoiceId } })
        this.talents = [...talent_leader, ...talents]
        this.$bvModal.hide('evaluation-starter')
        this.$bvModal.show('evaluation')
      } catch (error) {
        this.$toast_error({ message: 'Gagal memuat data talent. Silakan coba lagi.' })
      } finally {
        this.loading = false
      }
    },
    rateAndDisable() {
      const form = new FormData(this.$refs.evaluation)
      const data = Object.fromEntries(form.entries())
      const ratedTalent = Object.keys(data).filter(key => key.startsWith('rate-'))
      const isDisabled = ratedTalent.length < this.talents.length
      if (!isDisabled) {
        this.$refs.submit.disabled = false
        this.$refs.submit.classList.remove('disabled')
      }
      return { data, isDisabled }
    },
    formData() {
      const { data, isDisabled } = this.rateAndDisable()
      if (isDisabled) return { value: [], isDisabled }

      const transformedData = this.talents.map((talent, idx) => ({
        talent_id: talent.talent_id || null,
        rating: +data[`rate-${idx}`],
        evaluation: data[`eval-${idx}`],
        job_assignee_id: talent.job_assignee_id || null,
        staff_id: talent.staff_id || null,
      }))
      return { value: transformedData, isDisabled }
    },
    handleSelectAllInput({ target: { checked } }) {
      const talents = document.querySelectorAll('input[name="select-talent"]')
      Array.from(talents).forEach(el => {
        const t = el
        t.checked = checked
      })
    },
    handleSelectInput() {
      const all = document.getElementById('select-all')
      const talents = document.querySelectorAll('input[name="select-talent"]')
      all.checked = Array.from(talents).every(t => t.checked)
    },
    handleToggleEvaluation(idx) {
      const evaluation = document.getElementById(`eval-${idx}`)
      const arrow = document.getElementById(`arrow-${idx}`)
      if (evaluation.rows === 1) {
        evaluation.rows = 4
        arrow.classList.add('rotate-180')
        return
      }
      evaluation.rows = 1
      arrow.classList.remove('rotate-180')
    },
    handleEvaluationInput({ target: { value } }, idx) {
      const counter = document.getElementById(`counter-${idx}`)
      counter.textContent = `${value.length} karakter`
    },
    handleSelectRate({ target: { value } }) {
      this.rateAndDisable()
      const talents = document.querySelectorAll('input[name="select-talent"]')
      const rates = this.$refs.rate
      talents.forEach((talent, idx) => {
        if (talent.checked) {
          const selectedRate = rates[idx].querySelector(`input[value="${value}"]`)
          selectedRate.click()
        }
      })
    },
    async handleSubmitEvaluation() {
      if (this.loading) return
      const { value, isDisabled } = this.formData()
      if (isDisabled) return

      const keywords = ['asdf', 'qwer', '1234', 'abcd', 'test', 'tes', 'coba', 'good', 'nice', 'ok', 'oke', 'ya', 'tidak', 'bagus', '\\.\\.\\.', ',,,,', ';;;;', '::::', '!!!!']
      const escapedKeywords = keywords.map(k => k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
      const repeatedCharPattern = new RegExp(`(?:^|\\s)(${escapedKeywords.join('|')})(?:\\s+\\1){2,}(?=$|\\s)`, 'i')
      const poinPerValidEvalution = 500

      this.amount = value.reduce((acc, val) => {
        const isSatisfyMinChar = val.evaluation.length >= 20
        const isContainAlpha = /[a-z]/i.test(val.evaluation)
        const isCleanFromRepeatedChar = !/(.)\1{2,}/.test(val.evaluation)
        const isCleanFromRepeatedKeyword = !repeatedCharPattern.test(val.evaluation.toLowerCase())

        if (isSatisfyMinChar && isContainAlpha && isCleanFromRepeatedChar && isCleanFromRepeatedKeyword) {
          return acc + poinPerValidEvalution
        }
        return acc
      }, 0)

      const data = {
        evaluations: value,
        amount: this.amount,
        invoice_id: this.invoiceId,
      }

      try {
        this.loading = true
        await komtimAxiosIns.post('/v1/evaluations', data)
        this.$bvModal.hide('evaluation')
        this.$bvModal.show('evaluation-success')
      } catch (error) {
        this.$toast_error({ message: 'Gagal mengirim evaluasi talent. Silakan coba lagi.' })
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.rate {
    border-color: #E2E2E2;
}
.rate:has(:checked),
.rate:has(:checked) ~ .rate {
    background-color: #FFECE9;
    border-color: #F95031;
    color: #F95031;
}
.placeholder-ellipsis::placeholder {
  overflow: hidden;
  white-space: nowrap;
}
</style>
